import { SvgIcon } from "@mui/material"

import { ReactComponent as NotUsableIcon } from "./not-usable.svg"

export const StatusNotUsableIcon = (props) => {
    return (
        <SvgIcon component={NotUsableIcon} {...props} inheritViewBox />
    )
}